(function ($) {
    $(document).ready(function () {
        var acc = document.getElementsByClassName("accordion-filter");
        var i;

        for (i = 0; i < acc.length; i++) {
            acc[i].addEventListener("click", function () {
                this.classList.toggle("accordion-active");
                var panel = this.nextElementSibling;
                if (panel.style.maxHeight) {
                    panel.style.maxHeight = null;
                    panel.style.paddingBottom = 0;
                }
                else {
                    if (panel.classList.contains('ProductMeta__Review')) {
                        panel.style.maxHeight = 500 + "px";
                    }
                    else if (panel.classList.contains('ProductMeta__Find_Us')) {
                        panel.style.maxHeight = 100 + "%";
                        panel.style.paddingBottom = 15 + "px";
                    }
                    else {
                        panel.style.maxHeight = 200 + "px";
                    }
                }
            });
        }

        if ($('.filter-form').length) {
            let input = $('.filter-form').find('input')
            $.each(input, function (i, v) {
                $(v).change(function () {
                    if ($(v).attr('type') != 'range') {
                        $('.filter-form').trigger('submit')
                    }
                })
            })
        }

        if ($('.filter-group-size label')) {
            let checkSize = $('.filter-group-Size label input')
            $.each(checkSize, function (i, v) {
                if ($(v).is(":checked")) {
                    $(v).parent('label').addClass('active')
                }
                else {
                    $(v).parent('label').removeClass('active')
                }
            })

            $(checkSize).change(function () {
                if ($(this).is(":checked")) {
                    $(this).parent('label').addClass('active')
                }
                else {
                    $(this).parent('label').removeClass('active')
                }
            })
        }

        if (window.location.search) {
            const urlParams = new URLSearchParams(window.location.search);
            const filter_tag = urlParams.get('filter.p.tag')
            const filter_all = urlParams.getAll('filter.p.tag')

            if ($('input[name="filter.p.tag"]').length) {
                $.each($('input[name="filter.p.tag"]'), function (i, v) {
                    if (filter_all.indexOf($(v).val()) !== -1) {
                        $(v).parent('label').addClass('active')
                        $(v).attr('checked', true)
                    }
                })
            }

            const filter_size = urlParams.get('filter.v.option.size')
            const filter_size_all = urlParams.getAll('filter.v.option.size')

            if ($('input[name="filter.v.option.size"]').length) {
                $.each($('input[name="filter.v.option.size"]'), function (i, v) {
                    console.log('option.size', $(v))

                    if (filter_size_all.indexOf($(v).val()) !== -1) {
                        $(v).parent('label').addClass('active')
                        $(v).attr('checked', true)
                    }
                })
            }

            const filter_range_gte = urlParams.get('filter.v.price.gte')
            const filter_range_lte = urlParams.get('filter.v.price.lte')

            $('#fromSlider').val(filter_range_gte);
            $('#toSlider').val(filter_range_lte);
            $('#fromInput').attr('data-number', filter_range_gte);
            $('#toInput').attr('data-number', filter_range_lte);

            $('#toSlider').trigger("input");
        }

        $('#toggleFilterDinamisOpen').click(function () {
            $('#filter-container-dinamis').addClass('active')
        })

        $('#toggleFilterDinamisClose').click(function () {
            $('#filter-container-dinamis').removeClass('active')
        })
    })

})(jQuery);
